import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { selfieCopy } from '@/Pages/Selfie/copy';
import '@/Pages/Selfie/SelfiePage.sass';

type Props = {
  canGoBack?: boolean
  onBack?: () => void
  title?: string
  description?: string
}

export function SelfieHeader({ canGoBack = false, onBack, title, description }: Props): JSX.Element {
  return (
    <Box component="header" className="selfie-header" data-testid="selfie-header">
      {canGoBack && (
        <Button
          type="button"
          variant="text"
          color="inherit"
          startIcon={<ArrowBackRoundedIcon aria-hidden fontSize="small" />}
          className="selfie-header__back"
          data-testid="selfie-header-back"
          onClick={onBack}
        >
          Voltar
        </Button>
      )}
      <Typography component="h1" className="selfie-header__title">
        {title ?? selfieCopy.title}
      </Typography>
      <Typography component="p" className="selfie-header__description">
        {description ?? selfieCopy.description}
      </Typography>
    </Box>
  );
}
